export const productsIcon = `
<svg width="100%" height="100%" viewBox="0 0 26 26" fill="none" xmlns="http://www.w3.org/2000/svg">
<rect width="26" height="26"  />
<rect x="4" y="4" width="7" height="7" rx="1" stroke="currentColor" stroke-width="2"/>
<rect x="4" y="15" width="7" height="7" rx="1" fill="currentColor" stroke="currentColor" stroke-width="2"/>
<rect x="15" y="4" width="7" height="7" rx="1" stroke="currentColor" stroke-width="2"/>
<rect x="15" y="15" width="7" height="7" rx="1" stroke="currentColor" stroke-width="2"/>
</svg>
`;
